<p>componente-customscript works!</p>
<button (click)="customScript()">customScript</button>